<template>
	<Teleport to="body">
		<div
			v-for="entry in entries"
			:key="entry.name"
			class="vm--container"
		>
			<div class="vm--overlay" @click="close(entry.name)" />

			<div
				class="vm--modal"
				:style="{ width: widthOf(entry) }"
				role="dialog"
				aria-modal="true"
			>
				<component :is="entry.component" v-bind="entry.props" />
			</div>
		</div>
	</Teleport>
</template>

<script>
/**
 * Host for modals opened with a component rather than declared in a template,
 * i.e. `$modal.show(PopupConfirm, props, { name, width })`. vue-js-modal did
 * this by mounting a second Vue instance; under Vue 3 one host rendered once
 * in App.vue is enough.
 */
import { modal, modalState } from '@/plugins/modal';

export default {
	/**
	 * Name
	 */
	name: 'ModalHost',

	/**
	 * Computed
	 */
	computed: {
		entries() {
			return modalState.dynamic;
		}
	},

	/**
	 * Methods
	 */
	methods: {
		widthOf(entry) {
			const width = entry.options && entry.options.width;
			if (!width) return '600px';
			return typeof width === 'number' ? `${width}px` : width;
		},
		close(name) {
			modal.hide(name);
		}
	}
};
</script>
